  /*global jQuery */
	(function($) {
		
	'use strict';

  $('.banners').owlCarousel({
			loop:true,
			interval: 2000,
			pause: "false",
			smartSpeed: 1000,
			items:1,
			dots: false,
			autoplay:false,
			autoplayTimeout:5000,
			autoplayHoverPause:false,
			nav: true,
			navText : ['<span class="glyphicon glyphicon-chevron-left" style="top: 11px;color:grey;"></span>','<span class="glyphicon glyphicon-chevron-right" style="top: 11px;color:grey;"></span>'],
		});

  

}(jQuery));
